// src/domains/dash.keys.ts —— 模板键归属（TD-823）：原型键 44（仪表盘 / 上游 / Telegram Bot / 角色四片）+ D24 搭壳偏差块新增 7 键（0073 / 0152）
// + 0204 dev:C-15 块新增 1 键（miniLabels，菜单按钮文案 S-57）+ 0205 dev:C-33 广告推送页 1 键（bc，0049）
export const KEYS = [
  'chart', 'chartEnd', 'chartStart', 'goLogs', 'goReview', 'goUpstream', 'goUsers', 'kpis', 'newUsers', 'pendingList', 'recentHooks',
  'creds', 'endpoints', 'merchantLedger', 'rotateKeys', 'syncWallet', 'testHook',
  'addCmd', 'addKey', 'botBasic', 'botDirty', 'botTexts', 'botTopup', 'busyTgSave', 'cmdRows', 'curBotIdText', 'curBotName', 'curBotOwner', 'curBotUser',
  'keyRows', 'menuTypes', 'miniKnob', 'miniStyle', 'miniToggle', 'previewJson', 'saveBot', 'setHook', 'testMe', 'tgStats',
  'addRole', 'curRoleName', 'delRole', 'permRows', 'roles',
  'pendingEmpty', 'newUsersEmpty', 'hooksEmpty', 'endpointsEmpty', 'ledgerEmpty', 'fh', 'up',
  'miniLabels',
  'bc',
] as const;
